import type { SimulatedWorker } from './simulatorModel.js'

/**
 * Names the real worker whose score is on the desk, so nobody mistakes
 * their numbers for made-up activity - or the faders for a way to change
 * their score. Shown only when the simulator was opened from a worker.
 */
export function SimulatedWorkerBanner({ subject }: { subject: SimulatedWorker }) {
  const facility = subject.facilityName ?? subject.facilityId
  return (
    <section aria-label="Worker being simulated" className="rounded-lg border border-coral bg-zinc-950 px-4 py-3 shadow-md">
      <div className="flex flex-wrap items-end justify-between gap-x-8 gap-y-2">
        <div className="min-w-0">
          <div className="text-[9px] font-black uppercase tracking-[3px] text-coral">Simulating a real worker</div>
          <div className="truncate text-xl font-black leading-tight text-white">{subject.workerName}</div>
          <div className="text-sm font-bold text-white/80">{facility ?? 'Facility unknown'}</div>
        </div>
        <dl className="flex flex-wrap gap-x-6 gap-y-1 text-[11px] text-white/60">
          <div>
            <dt className="text-[9px] font-bold uppercase tracking-widest text-white/45">Worker ID</dt>
            <dd className="font-mono text-white">{subject.workerId}</dd>
          </div>
          {subject.facilityId !== null && subject.facilityName !== null && (
            <div>
              <dt className="text-[9px] font-bold uppercase tracking-widest text-white/45">Facility ID</dt>
              <dd className="font-mono text-white">{subject.facilityId}</dd>
            </div>
          )}
          <div>
            <dt className="text-[9px] font-bold uppercase tracking-widest text-white/45">Period</dt>
            <dd className="font-mono text-white">{subject.period}</dd>
          </div>
        </dl>
      </div>
      <p className="mt-2 text-[11px] text-white/50">Moving a fader changes nothing for this worker. Reset to go back to made-up activity.</p>
    </section>
  )
}
